export const DynamicLoaderAssets = {
  GoogleAuthScript: 'https://accounts.google.com/gsi/client',
  GoogleMapsScript: 'https://maps.googleapis.com/maps/api/js?key={TOKEN}&libraries=places&callback=Function.prototype',
  IntercomScript: 'https://widget.intercom.io/widget/tnpm21gx',
  LottiePlayer: 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js',
  ReCaptcha: 'https://www.google.com/recaptcha/api.js?render=explicit&onload=ng2recaptchaloaded&hl={TOKEN}',
  StripeScriptV3: 'https://js.stripe.com/v3/',
  YoutubeIframeScript: 'https://www.youtube.com/iframe_api',
} as const;

export type DynamicLoaderAssets = (typeof DynamicLoaderAssets)[keyof typeof DynamicLoaderAssets];
